import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import services from "../data/servicesData";

// Stilizare pentru butonul de serviciu
const ServiceButton = styled(Button)(({ active }) => ({
  width: "100%",
  textAlign: "center",
  backgroundColor: active ? "#2B4D30" : "#4D8F55",
  color: "white",
  fontWeight: "bold",
  marginBottom: "1.5em",
  padding: "1em",
  boxShadow: active
    ? "inset 3px 3px 8px #1a2f1d, inset -3px -3px 8px #2B4D30"
    : "3px 3px 8px rgba(0, 0, 0, 0.1)",
  border: active ? "1px solid #1a2f1d" : "1px solid #4D8F55",
  "&:hover": {
    backgroundColor: "#2B4D30",
    color: "white",
  },
}));

// Stilizare pentru containerul de conținut
const ContentBox = styled(Box)({
  padding: "2em",
  marginTop: "20px",
  "& p": {
    margin: "10px 0",
  },
});

const ServicesContainer = styled(Container)({
  marginTop: "40px",
  marginBottom: "40px",
});

const DataCertText = styled(Typography)({
  textAlign: "left",
  fontSize: "1rem",
  marginBottom: "10px",
  fontWeight: "bold",
});

const Services = () => {
  const location = useLocation();
  const { selectedIndex = 0 } = location.state || {};
  const [selectedService, setSelectedService] = useState(services[selectedIndex]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const selectedServiceRef = useRef(null);

  // Scroll to selected service when it changes
  useEffect(() => {
    if (selectedServiceRef.current) {
      const yOffset = -80; // Ajustează această valoare pentru scroll mai sus/jos
      const element = selectedServiceRef.current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, [selectedService]);

  // Update selected service when selectedIndex changes
  useEffect(() => {
    setSelectedService(services[selectedIndex]);
  }, [selectedIndex]);

  return (
    <ServicesContainer>
      {isMobile ? (
        // --- Varianta pe mobil: fiecare buton + text sub el ---
        <Box>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", textAlign: "left" }}
          >
            Serviciile noastre
          </Typography>
          {services.map((service, index) => {
            const isActive = selectedService.title === service.title;
            return (
              <Box key={index} ref={isActive ? selectedServiceRef : null}>
                {/* Butonul */}
                <ServiceButton
                  variant="contained"
                  active={isActive}
                  onClick={() => setSelectedService(service)}
                >
                  {service.title}
                </ServiceButton>
                {/* Afișăm textul doar dacă e serviciul selectat */}
                {isActive && (
                  <ContentBox>
                    <DataCertText variant="body1">Datacert</DataCertText>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{ textAlign: "left", fontSize: "1.8rem" }}
                    >
                      {service.title}
                    </Typography>
                    <ul>
                      {Array.isArray(service.content)
                        ? service.content.map((point, index) => (
                            <li key={index} style={{ marginBottom: "8px" }}>{point}</li>
                          ))
                        : <Typography variant="body1">{service.content}</Typography>}
                    </ul>
                  </ContentBox>
                )}
              </Box>
            );
          })}
        </Box>
      ) : (
        // --- Varianta pe desktop: coloana cu butoane stânga, textul în dreapta ---
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", textAlign: "left" }}
            >
              Serviciile noastre
            </Typography>
            {services.map((service, index) => (
              <ServiceButton
                key={index}
                variant="contained"
                active={selectedService.title === service.title}
                onClick={() => setSelectedService(service)}
              >
                {service.title}
              </ServiceButton>
            ))}
          </Grid>

          <Grid item xs={12} md={8}>
            <ContentBox>
              <DataCertText variant="body1">Datacert</DataCertText>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ textAlign: "left", fontSize: "1.8rem" }}
              >
                {selectedService.title}
              </Typography>
              <ul>
                {Array.isArray(selectedService.content)
                  ? selectedService.content.map((point, index) => (
                      <li key={index} style={{ marginBottom: "8px" }}>{point}</li>
                    ))
                  : <Typography variant="body1">{selectedService.content}</Typography>}
              </ul>
            </ContentBox>
          </Grid>
        </Grid>
      )}
    </ServicesContainer>
  );
};

export default Services;
